import {
  AsyncGridColumns,
  ColumnChipList,
  ColumnLink,
} from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.designation',
    field: 'name',
    sortable: false,
    flex: 1,
    minWidth: 300,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.name}</ColumnLink>,
  },
  {
    headerName: 'column.access rights',
    field: 'permissions',
    sortable: false,
    flex: 1,
    minWidth: 300,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
]
